import { Link } from 'react-router-dom';
import { ArrowRight, Quote } from 'lucide-react';

const CEODesk = () => {
  return (
    <div className="min-h-screen pt-20" data-testid="ceo-desk-page">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-blue-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <div className="inline-flex items-center px-4 py-2 bg-[#1E88E5]/10 rounded-full text-[#1E88E5] font-medium text-sm mb-6">
                From the Founder's Desk
              </div>
              <h1 className="font-heading text-4xl md:text-5xl font-bold text-[#0B2C5D] mb-4">
                A Message from Our Founder
              </h1>
            </div>

            <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12">
              <div className="flex justify-center mb-8">
                <img 
                  src="/images/founder.jpg"
                  alt="Dr. Swamy K N - Founder"
                  className="w-32 h-32 rounded-full object-cover shadow-lg border-4 border-[#1E88E5]"
                />
              </div>

              <div className="relative">
                <Quote className="absolute -top-4 -left-4 h-12 w-12 text-[#1E88E5]/20" />
                <blockquote className="text-xl md:text-2xl text-[#0B2C5D] leading-relaxed text-center italic mb-8">
                  "At Washora, we believe every vehicle deserves professional care without the customer having to step out. Our mission is simple – deliver premium service at your doorstep, save your time, and ensure your car always looks its best."
                </blockquote>
              </div>

              <div className="text-center">
                <p className="font-heading text-xl font-bold text-[#0B2C5D]">
                  Dr. Swamy K N
                </p>
                <p className="text-[#1E88E5] font-medium">
                  Founder & MD, Washora - Premium Care
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-[#0B2C5D] mb-8 text-center">
              The Vision Behind Washora
            </h2>
            
            <div className="space-y-6 text-lg text-[#64748B] leading-relaxed">
              <p>
                When I started Washora, I had a simple observation: car owners in Karnataka, especially outside Bangalore, were struggling with quality car care services. The traditional options meant wasting precious weekend hours, dealing with inconsistent service quality, and often worrying about vehicle safety.
              </p>
              <p>
                I envisioned a service that would bring professional, premium car care directly to where customers need it most – their homes, offices, and communities. A service that respects their time while delivering uncompromising quality.
              </p>
              <p>
                Today, Washora stands as Core Karnataka's First Doorstep Car Wash Service beyond the capital, and we're just getting started. Our commitment to excellence, eco-friendly practices, and customer satisfaction remains unwavering.
              </p>
              <p>
                Thank you for trusting us with your vehicles. Every car we wash is a testament to our commitment to your satisfaction.
              </p>
            </div>

            <div className="mt-12 p-8 bg-[#F7931E]/10 rounded-2xl border-l-4 border-[#F7931E]">
              <p className="font-heading text-xl font-semibold text-[#0B2C5D]">
                "Our goal is not just to wash cars, but to give our customers back their most valuable asset – time."
              </p>
              <p className="mt-4 text-[#64748B]">— Dr. Swamy K N</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-[#1E88E5] to-[#0B2C5D]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-6">
            Experience the Washora Difference
          </h2>
          <p className="text-white/80 max-w-2xl mx-auto mb-8">
            Join thousands of satisfied customers who trust us with their vehicles.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/booking"
              className="bg-[#F7931E] text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-[#E08215] transition-all transform hover:-translate-y-0.5 shadow-lg flex items-center justify-center"
              data-testid="ceo-book-now"
            >
              Book Your First Wash <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
            <Link
              to="/vision-mission"
              className="bg-white text-[#0B2C5D] px-8 py-4 rounded-full font-semibold text-lg hover:bg-slate-100 transition-all flex items-center justify-center"
            >
              Our Vision & Mission
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CEODesk;
